
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 22 22"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","d":"M13.25 14v-1.5c.338-.168 1.303-1.317 1.405-2.214.265-.02.682-.264.805-1.227.066-.516-.196-.807-.356-.898 0 0 .397-.753.397-1.66 0-1.822-.715-3.376-2.25-3.376 0 0-.534-1.125-2.25-1.125-3.182 0-4.5 2.04-4.5 4.5 0 .828.395 1.66.395 1.66-.159.092-.421.383-.355.9.123.962.54 1.205.805 1.226.101.897 1.067 2.046 1.404 2.214V14C8 16.25 2 14.75 2 20h18c0-5.25-6-3.75-6.75-6z"}})])
          )
        }
      }
    